import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {BaseService} from '../base/service.base';
import {MachineMaintenance} from '../models/machine.maintenance.model';
import {share} from 'rxjs/operator/share';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class MachineMaintenanceService extends BaseService {
  private _maintenances$: BehaviorSubject<MachineMaintenance[]>;
  private _dataStore: {
    maintenances: MachineMaintenance[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {maintenances: []};
    this._maintenances$ = <BehaviorSubject<MachineMaintenance[]>>new BehaviorSubject([]);
  }

  get maintenances$() {
    return this._maintenances$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/machinemaintenances${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.maintenances = result;
      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not load machinemaintenances.'));
  }

  public load(id: any) {
    this._http.get(`${this.baseApiUrl}/machinemaintenances/${id}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      let notFound = true;

      this._dataStore.maintenances.forEach((item, index) => {
        if (item._id === result._id) {
          this._dataStore.maintenances[index] = result;
          notFound = false;
        }
      });

      if (notFound) {
        this._dataStore.maintenances.push(result);
      }

      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not load machinemaintenances.'));
  }

  public loadMachineHistory(machineId: any) {
    this._http.get(`${this.baseApiUrl}/machinemaintenances/${machineId}/machinehistory`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.maintenances = result;
      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not load machinemaintenances.'));
  }

  public create(maintenance: MachineMaintenance): Observable<any> {
    const shareable = this._http.post(`${this.baseApiUrl}/machinemaintenances`, JSON.stringify(maintenance), {headers: postContentHeaders})
      .map(response => response.json()).share();
    shareable.subscribe(result => {
      this._dataStore.maintenances.push(result);
      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not create maintenance.'));

    return shareable;
  }

  public update(maintenance: MachineMaintenance): Promise<any[]> {
    const promise: Promise<any[]> = new Promise((resolve, reject) => {
      this._http.put(`${this.baseApiUrl}/machinemaintenances/${maintenance._id}`, JSON.stringify(maintenance), {headers: postContentHeaders})
        .map(response => response.json()).subscribe(result => {
        this._dataStore.maintenances.forEach((defi, i) => {
          if (defi._id === result._id) {
            this._dataStore.maintenances[i] = result;
          }
        });

        this._maintenances$.next(this._dataStore.maintenances);
        resolve(this._dataStore.maintenances);
      }, error => {
          console.error('Could not update machinemaintenances.');
          reject(error);
      });
    });

    return promise;
  }

  public remove(maintenanceId: string) {
    this._http.delete(`${this.baseApiUrl}/machinemaintenances/${maintenanceId}`).subscribe(response => {
      this._dataStore.maintenances.forEach((t, i) => {
        if (t._id === maintenanceId) {
          this._dataStore.maintenances.splice(i, 1);
        }
      });

      this._maintenances$.next(this._dataStore.maintenances);
    }, error => console.error('Could not delete machinemaintenances.'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/machine.maintenance.service.ts